import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import ErrorBoundary from "components/Error/errorBoundary";

export default function DashboardListingState({isLoading, noResults, isError, refreshCallback}) {
    const {t} = usePolTranslation();

    return (
        <ErrorBoundary refreshCallback={refreshCallback} isErrorShowing={isError} canRetry>
            <div className={`dashboard-listing__state ${noResults ? 'no-results' : ''}`}>
                {isLoading && (
                    <>
                        <PolIcon icon="circle-notch" className="spinner"/>
                        <p>{t('loading')}</p>
                    </>
                )}
                {!isLoading && noResults && (
                    <>
                        <PolIcon icon="search" className="icon"/>
                        <p>{t('no_results')}</p>
                    </>
                )}
            </div>
        </ErrorBoundary>
    )
}
